export default "__VITE_ASSET__BSwqbyVs__"